import init from '../../common/base/init';
import $ from 'jquery';

init(() => {
  if (!document.querySelectorAll('.seminar-questions')) return;

  const submitBtn = document.querySelector('.seminar-questions__btn');
  const closeSubmitMsgBtn = document.querySelector('.seminar-questions__submitted-msg button');
  const submitMsg = document.querySelector('.seminar-questions__submitted-msg');
  const questionInput = document.querySelector('.seminar-questions__form textarea');

  if (closeSubmitMsgBtn) {
    closeSubmitMsgBtn.onclick = () => {
      submitMsg.style.display = 'none';
    }
  }

  if (submitBtn && !submitBtn.disabled) {
    submitBtn.onclick = (e) => {
      e.preventDefault();

      const seminarId = submitBtn.id.split('-')[1];

      $.ajax({
        type: "POST",
        url:  `/api/v1/seminars/${seminarId}/questions.json`,
        data: { seminar_question: { body: questionInput.value } },
        success: (data) => {
          submitMsg.style.display = 'flex';
          questionInput.value = '';
          const questionsContainer = document.querySelector('.seminar-questions__placeholder');

          const newQuestionContainer = document.createElement('div');
          const newQuestionText = document.createElement('p');
          const newQuestionTimeStamp = document.createElement('span');
          
          const timeStamp = new Date(data.created_at);

          newQuestionContainer.classList.add('seminar-questions__question-container')
          newQuestionText.innerHTML = data.body;
          newQuestionTimeStamp.innerHTML = 
            `${String(timeStamp.getHours()).padStart(2, '0')}:${String(timeStamp.getMinutes()).padStart(2, '0')}`
          
          newQuestionContainer.append(newQuestionTimeStamp);
          newQuestionContainer.append(newQuestionText);

          questionsContainer.append(newQuestionContainer);
        },
        dataType: 'JSON'
      });
    } 
  }
 
});
